
import { useState } from 'react'
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import planetes from './planetes'

export default function Univers(props) {
    console.log(planetes)
    const open = props.open
    const setOpen = props.setOpen
    return (
        <Dialog open={open} onClose={() => { console.log("Close") }} className="relative z-10">
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-10 w-screen  h-full w-full overflow-y-auto">
                <div className="flex h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <DialogPanel
                        transition
                        className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95 " style={{ height: 90 + 'vh', width: 90 + 'vw' }}
                    >
                        <div className="bg-white   px-4 pb-4 pt-5 sm:p-6 sm:pb-4" style={{ height: 95 + '%' }}>
                            <div style={{ height: 95 + '%' }}>
                                <ul className='text-center'>
                                    {planetes.map((p, i) => {
                                        if (!p.disable) { return (<li key={i} onClick={e => { 
                                            props.setQuestions(p["questions"])
                                            setOpen(false)   }}> <button type="button" className="text-blue-700 bg-slate-100 text-3xl w-96 mt-20 py-10 fs-28   hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"> <img src="planete1.jpg" className="h-20 inline-block" alt="" /> {p["name"]}</button></li>) }
                                    })
                                    }
                                </ul>
                            </div>
                            <div className='text-right pr-10'>
                                <button
                                    type="button"
                                    data-autofocus
                                    onClick={() => setOpen(false)}
                                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>



                    </DialogPanel>
                </div>
            </div>
        </Dialog>
    )
}